import { Routes } from "@angular/router";
import { TRANSLATION_PATHS } from "@app/shared/general/translation/constants/translation.constant";
import { loadTranslationResolver } from "@kernel/translations/resolvers/load-translations.resolver";
import { DynamicFieldApiService } from "./domains/dynamic-fields/services/dynamic-field-api.service";
import { DynamicFormApiService } from "../../shared/dynamic-form/dynamic-forms/services/dynamic-form-api.service";

export const dynamicFormsRoutes: Routes = [
  {
    path: "dynamic-forms",
    loadChildren: () => import("./domains/dynamic-forms/dynamic-forms.routes").then(r => r.dynamicFormsRoutes),
    resolve: {
      translate: loadTranslationResolver([
        TRANSLATION_PATHS.ROOT,
        TRANSLATION_PATHS.DYNAMIC_FORM.DYNAMIC_FORMS,
        TRANSLATION_PATHS.DYNAMIC_FORM.DYNAMIC_FIELDS,
        TRANSLATION_PATHS.FILE_TYPES,
      ]),
    },
    providers: [DynamicFormApiService, DynamicFieldApiService],
  },
  {
    path: "dynamic-fields",
    loadChildren: () => import("./domains/dynamic-fields/dynamic-fields.routes").then(r => r.dynamicFieldsRoutes),
    resolve: {
      translate: loadTranslationResolver([TRANSLATION_PATHS.ROOT, TRANSLATION_PATHS.DYNAMIC_FORM.DYNAMIC_FIELDS, TRANSLATION_PATHS.FILE_TYPES]),
    },
    providers: [DynamicFieldApiService],
  },
];
